import React from 'react'; 
import './Hours.css'; 
import './Home.css'; 
import 'aos/dist/aos.css'; 
import '../The-Gallery/Visit-Us/Visit-Us.css'; 

function Visit() {

    return (
        <div id="visit"> 
          <h1 className="sub">Unique Art Sets Us Apart</h1> 
          <h3 className="paragraph">
            At American Dragon, we believe that quality is so much more important than quantity! Each work we display is meant to 
            be unlike any other, with their own extraordinary distinctions that cannot be recreated at the same caliber. 
          </h3> 
        </div> 
    );
  }
  
  export default Visit;
